export const EMPTY_CART: Cart = {
    cartItems: []
} as unknown as Cart;
